import { render, staticRenderFns } from "./royalties-chart.vue?vue&type=template&id=32dffb02"
import script from "./royalties-chart.vue?vue&type=script&lang=js"
export * from "./royalties-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports